module.exports = __webpack_public_path__ + "static/media/credit_card.061ca6fc.svg";